import { render } from "./GroupProductDetail.vue?vue&type=template&id=3c9d6f9d&scoped=true"
import script from "./GroupProductDetail.vue?vue&type=script&lang=js"
export * from "./GroupProductDetail.vue?vue&type=script&lang=js"

import "./GroupProductDetail.vue?vue&type=style&index=0&id=3c9d6f9d&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9d6f9d"]])

export default __exports__